// Permission Configuration
// Define available permissions and roles

export const PERMISSIONS = {
  // User Management
  MANAGE_USERS: 'manage_users',
  VIEW_USERS: 'view_users',
  
  // Sessions
  VIEW_SESSIONS: 'view_sessions',
  MANAGE_SESSIONS: 'manage_sessions',
  
  // Access Requests
  MANAGE_REQUESTS: 'manage_requests',
  VIEW_REQUESTS: 'view_requests',
  
  // Consultations
  VIEW_CONSULTATIONS: 'view_consultations',
  MANAGE_CONSULTATIONS: 'manage_consultations',
  
  // Payments
  VIEW_PAYMENTS: 'view_payments',
  MANAGE_PAYMENTS: 'manage_payments',
  
  // Bundles/Products
  MANAGE_BUNDLES: 'manage_bundles',
  VIEW_BUNDLES: 'view_bundles',
  
  // Settings
  MANAGE_SETTINGS: 'manage_settings',
  VIEW_SETTINGS: 'view_settings',
  
  // Admin
  ADMIN: 'admin', // Full access
};

export const ROLES = {
  ADMIN: 'admin',
  MANAGER: 'manager',
  SUPPORT: 'support',
  USER: 'user',
};

// Predefined role permissions
export const ROLE_PERMISSIONS = {
  [ROLES.ADMIN]: [
    PERMISSIONS.ADMIN, // Admin has all permissions
  ],
  
  [ROLES.MANAGER]: [
    PERMISSIONS.VIEW_USERS,
    PERMISSIONS.VIEW_SESSIONS,
    PERMISSIONS.MANAGE_REQUESTS,
    PERMISSIONS.VIEW_CONSULTATIONS,
    PERMISSIONS.VIEW_PAYMENTS,
    PERMISSIONS.MANAGE_BUNDLES,
    PERMISSIONS.VIEW_SETTINGS,
  ],
  
  [ROLES.SUPPORT]: [
    PERMISSIONS.VIEW_USERS,
    PERMISSIONS.VIEW_SESSIONS,
    PERMISSIONS.VIEW_REQUESTS,
    PERMISSIONS.VIEW_CONSULTATIONS,
    PERMISSIONS.VIEW_PAYMENTS,
    PERMISSIONS.VIEW_BUNDLES,
  ],
  
  [ROLES.USER]: [
    // Regular users have no admin panel access by default
  ],
};

// Helper function to check if user has permission
export const hasPermission = (userPermissions, requiredPermissions, userRole) => {
  if (!requiredPermissions || requiredPermissions.length === 0) return true;
  if (userRole === ROLES.ADMIN) return true; // Admin bypasses all checks
  
  const permissions = Array.isArray(userPermissions) 
    ? userPermissions 
    : (userPermissions ? JSON.parse(userPermissions) : []);
    
  return requiredPermissions.some(perm => permissions.includes(perm));
};

// Get all permissions for a role
export const getRolePermissions = (role) => {
  return ROLE_PERMISSIONS[role] || [];
};
